// extracted by mini-css-extract-plugin
export default {"WhoContent":"styles_WhoContent__LjwLP","headshot":"styles_headshot__oy95K","headshotWrapper":"styles_headshotWrapper__pXXqU","contactIcons":"styles_contactIcons__E96EG"};